import { Shirt } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export function LoginPage() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg)]">
      <div className="surface max-w-sm w-full p-8 text-center">
        <div className="w-16 h-16 rounded-2xl bg-[var(--accent-soft)] flex items-center justify-center mx-auto mb-6 border border-[var(--line)]">
          <Shirt className="w-8 h-8 text-[var(--accent)]" />
        </div>
        <h1 className="text-2xl font-semibold mb-2 text-[var(--ink)]">Stylist Compose</h1>
        <p className="text-sm text-[var(--muted)] mb-8">在线自由搭配平台</p>
        <button onClick={() => login()} className="btn-primary w-full">
          使用飞书登录
        </button>
      </div>
    </div>
  );
}
